import AccessError from './AccessError';
import FormError from './FormError';
import InvalidRequestError from './InvalidRequestError';
import ResourceError from './ResourceError';

export default function parseAPIError(error) {
  if (!error?.response) {
    console.error('Error', error);
    return error;
  }
  if (FormError.matchesFormat(error)) {
    return new FormError(error);
  }
  if (AccessError.matchesFormat(error)) {
    return new AccessError(error);
  }
  if (InvalidRequestError.matchesFormat(error)) {
    return new InvalidRequestError(error);
  }
  if (ResourceError.matchesFormat(error)) {
    return new ResourceError(error);
  }

  console.error('Error', error);
  return error;
}

export {
  AccessError,
  InvalidRequestError,
  ResourceError,
  FormError,
};
